import {
	IcoDelete,
	IcoEdit,
	IcoVehicleCar,
	IcoVehicleKombi,
	IcoVehicleTruck
} from "assets/icons";
import ActionButton from "components/ActionButton";
import styles from "./styles.module.scss";

import { RegisterItemProps } from "./types";

export default function RegisterItem({
	title,
	subtitle,
	carType,
	label,
	onEdit,
	onDelete
}: RegisterItemProps) {
	const getInitials = (name: string) => {
		const words = name.trim().split(/\s+/);
		if (words.length === 1) {
			return words[0].substring(0, 2).toUpperCase();
		}
		return (words[0][0] + words[1][0]).toUpperCase();
	};

	return (
		<div className={styles.container}>
			<div className={styles.logo}>
				{carType === "car" ? (
					<IcoVehicleCar />
				) : carType === "kombi" ? (
					<IcoVehicleKombi />
				) : carType === "truck" ? (
					<IcoVehicleTruck />
				) : (
					<span>{getInitials(title)}</span>
				)}
			</div>
			<div className={styles.info}>
				<div className={styles.title}>
					<span>{title}</span>
				</div>
				<span>{subtitle}</span>
			</div>
			<div className={styles.actionButtons}>
				{label && <span className={styles.label}>{label}</span>}
				<ActionButton icon={<IcoEdit />} text="" onClick={onEdit} />
				<ActionButton icon={<IcoDelete />} text="" onClick={onDelete} />
			</div>
		</div>
	);
}
